/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Summary_RefundedInputs */

const cs_deal_payments_summary_refunded = /** @type {(inputs: Deal_Payments_Summary_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrácené`)
};

const en_deal_payments_summary_refunded = /** @type {(inputs: Deal_Payments_Summary_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Deal_Payments_Summary_RefundedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_summary_refunded = /** @type {((inputs?: Deal_Payments_Summary_RefundedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Summary_RefundedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_summary_refunded(inputs)
	return cs_deal_payments_summary_refunded(inputs)
});